import React, { useState, useEffect } from 'react';
import { useGame } from '../context/GameContext';
import parse from 'html-react-parser';
import { getText } from '../../../utils/languageUtils';

const GameBoard = ({ level, onExitGame, question, language }) => {
  const [cards, setCards] = useState([]);
  const [flippedIndices, setFlippedIndices] = useState([]);
  const [matchedIndices, setMatchedIndices] = useState([]);
  const [flipCount, setFlipCount] = useState(0);
  const [correctMatch, setCorrectMatch] = useState(0);
  const [wrongMatch, setWrongMatch] = useState(0);
  const [lockBoard, setLockBoard] = useState(false);
  const [gameFailed, setGameFailed] = useState(false);


  const { state, dispatch } = useGame();
  const { stats } = state;


  useEffect(() => {
    const generateCardsFromQuestion = () => {
      const options = [...(question?.question_option || [])];
      const titleCards = [];
      const infoCards = [];

      options.forEach((item) => {
        titleCards.push({
          id: item.id,
          type: "title",
          content: getText(item.title, language),
          image: getText(item.file_path, language) || null,
        });

        infoCards.push({
          id: item.id,
          type: "info",
          content: getText(item.info, language),
          image: null,
        });
      });

      // Shuffle cards
      const shuffle = (arr) => arr.sort(() => Math.random() - 0.5);

      let shuffledTitles = shuffle([...titleCards]);
      let shuffledInfos = [];

      const isValidPairing = (titles, infos) =>
        titles.every((card, idx) => card.id !== infos[idx]?.id);

      let attempts = 0;
      const MAX_ATTEMPTS = 100;

      do {
        shuffledInfos = shuffle([...infoCards]);
        attempts++;
      } while (!isValidPairing(shuffledTitles, shuffledInfos) && attempts < MAX_ATTEMPTS);

      // Interleave into column-major order (left col then right col)
      const arrangedCards = [];
      for (let i = 0; i < shuffledTitles.length; i++) {
        arrangedCards.push(shuffledTitles[i]); // left column (title)
        arrangedCards.push(shuffledInfos[i]);  // right column (info)
      }

      setCards(arrangedCards);
      setFlippedIndices([]);
      setMatchedIndices([]);
      setFlipCount(0);
      setCorrectMatch(0);
      setWrongMatch(0);
      setLockBoard(false);
    };

    generateCardsFromQuestion();
  }, [question, language]);






  const handleCardClick = (index) => {
    if (lockBoard || flippedIndices.includes(index) || matchedIndices.includes(index)) return;

    const newFlipped = [...flippedIndices, index];
    setFlippedIndices(newFlipped);

    if (newFlipped.length === 2) {
      setLockBoard(true);
      setFlipCount((prev) => prev + 1);

      const [i1, i2] = newFlipped;
      const card1 = cards[i1];
      const card2 = cards[i2];
      const isMatch = card1.id === card2.id && card1.type !== card2.type;

      setTimeout(() => {
        if (isMatch) {
          setMatchedIndices((prev) => [...prev, i1, i2]);
          setCorrectMatch((prev) => prev + 1);
        } else {
          setWrongMatch((prev) => prev + 1);
        }
        setFlippedIndices([]);
        setLockBoard(false);
      }, 10000);
    }
  };

  useEffect(() => {
    if (gameFailed) {
      dispatch({
        type: 'SAVE_STATS',
        payload: {
          flips: flipCount,
          correct: correctMatch,
          wrong: wrongMatch,
          level,
          result: 'fail'
        }
      });
      onExitGame();
      return;
    }
    if (matchedIndices.length > 0 && matchedIndices.length === cards.length) {
      dispatch({
        type: 'SAVE_STATS',
        payload: {
          flips: flipCount,
          correct: correctMatch,
          wrong: wrongMatch,
          level,
          result: 'win',
        },
      });
      onExitGame();
    }
  }, [matchedIndices]);

  const renderCard = (card) => {
    if (!card || !card.type) return null;

    if (card.type === 'info') {
      return (
        <div className="flipper">
          <div className="f"></div>
          <div className="b info-text">
            <div className="d-flex flex-column align-items-center justify-content-center w-100 h-100 px-2  text-center gap-2">
              {parse(card.content ?? '')}
            </div>
          </div>
        </div>
      );
    }

    if (card.type === 'title') {
      return (
        <div className="flipper">
          <div className="f"></div>
          <div className="b">
            <div className="d-flex flex-column align-items-center justify-content-center w-100 h-100 px-2 text-center gap-2">
              <div className="title-text w-100">{parse(card.content ?? '')}</div>
              {card.image && (
                <img
                  src={card.image}
                  alt="card"
                  className="img-fluid"
                  style={{ maxWidth: '100%', maxHeight: '120px', objectFit: 'contain' }}
                />
              )}
            </div>
          </div>
        </div>
      );
    }

    return null;
  };


  return (
    <>
      <div
        className="card-board mb-3"
      >
        {cards.map((card, index) => {
          const isFlipped = flippedIndices.includes(index) || matchedIndices.includes(index);
          const isFound = matchedIndices.map((i) => cards[i]?.id).includes(card.id);


          return (
            <div
              key={index}
              className={`card gamecard ${isFlipped ? 'active' : ''} ${isFound ? 'found' : ''}`}
              onClick={() => handleCardClick(index)}
          
            >
              {!isFound && renderCard(card)}
            </div>
          );
        })}
      </div>
      {/* <div className="d-flex gap-3 mb-2" >
        <div>Total Flips: {flipCount}</div>
        <div>Matches: {correctMatch}</div>
        <div>Wrong: {wrongMatch}</div>
      </div> */}
    </>
  );
};

export default GameBoard;
